module.exports = __webpack_public_path__ + "static/media/assassin_female.7f71fc11.png";